import { toastAtom } from './atoms';
import { useRecoilState } from 'recoil';
import { ReactElement, useCallback } from 'react';
import { ToastType } from './types';
import { SxProps, Theme } from '@mui/material';

export const useToast = () => {
  const [toastState, setToastState] = useRecoilState(toastAtom);

  const showToast = useCallback(
    ({
      message,
      title,
      type = ToastType.Info,
      sx
    }: {
      title?: string;
      message?: string | ReactElement;
      type: ToastType;
      sx?: SxProps<Theme>;
    }) => {
      setToastState({ open: true, message, title, type, sx });
    },
    [setToastState]
  );

  const hideToast = useCallback(() => {
    setToastState((prev) => ({ ...prev, open: false }));
  }, [setToastState]);

  return {
    showToast,
    hideToast,
    toastState
  };
};
